import React, { Component } from 'react';
import { Row, Col, DropdownButton, Dropdown, Accordion, Card } from "react-bootstrap";
import { Button, FlagDropDown } from "../common";
import './RegistrationView.scss';
import KeellsLogo from '../../assets/img/logo/KeellsWhiteLogo.png'
import Timer from './../loginView/Timer';
import { get, post } from './../../utility/apiClient';
import { errorTypesEnum } from './../../utility/enums';
import { checkPasswordComplexity } from '../../utility/commonFunctions';
import { GtagEvent } from '../../utility/googleAnalytics';
import { countries } from '../../components/common/flagDropDown/countries';
import Select from 'react-select';
/**-- Imports for redux --*/
import { connect } from 'react-redux';
import { showMessageBox } from '../../redux/actions/messageBoxActions';
import { showLoadingScreen, hideLoadingScreen } from '../../redux/actions/loadingScreenActions';


// map the redux states to props
function mapStateToProps(state) {
    return {
        responsive: state.responsive,
        loadingScreenVisible: state.loadingScreen,
        customerData: state.customerDetail,
        selectedEssentialPackagesList: state.selectedEssentialPackages,
        systemConfigurationData: state.systemConfiguration
    }
};

// map the redux actions to props
const mapDispatchToProps = {
    showMessageBox,
    showLoadingScreen,
    hideLoadingScreen,
};

class RegistrationView extends Component {

    state = {
        // Step one
        UserName: '',
        Password: '',
        MobileNumber: '',
        OTPNumber: '',
        mobileCountryCode: '+94',

        // Step two
        FirstName: '',
        LastName: '',
        AddressLine1: '',
        AddressLine2: '',
        Email: '',
        City: '',
        Password: '',
        ConfirmPassword: '',
        Title: 'Title',

        // validations
        // Step 1
        isCheckingLoginValidity: false,
        isCheckingOTPValidity: false,
        isCheckingMobileNumberValidity: false,
        isCheckingRegistration: false,

        // Step 2
        isFirstNameNotValid: false,
        isLastNameNotValid: false,
        isAddressLine1NotValid: false,
        isAddressLine2NotValid: false,
        isEmailNotValid: false,
        isWrongEmailAddress: false,
        isPasswordNotValid: false,
        passwordError: "",
        isConfirmPasswordNotValid: false,
        isCountryNotAllowed: false,
        isCityNotValid: false,
        isTitleNotValid: false,

        isMobileNumberNotValid: true,
        isOTPNotValid: true,

        isRequestSent: false,
        isDisabledResend: false,
        isOTPValidate: false,

        // keys
        timerKey: 0,

        activeView: 1,
        OTPKey: '',
        messageBox: {
            show: false,
            title: "",
            className: "",
            content: "",
            callBackFunction: null
        },

        //Next Active Inactive
        isNextActive: true,
        isNexusMember: false,
        nexusCustID:'',

        countryList: [],
        countryKey: 0,
        selectedCountry: 'LK',
        countryplaceholder: "Sri Lanka"
    }

    componentDidMount() {
        this.loadCountryCodes();
    }

    loadCountryCodes() {
        get("/Common/GetCountryCodes").then(response => {
            if (response.data.statusCode == 200) {
                let cityList = response.data.result.map(i => {
                    return {
                        value: i.countryCode,
                        label: i.countryName
                    };
                });
                if (response.data.result) {
                    this.setState({
                        countryList: cityList,
                    }, () => { })
                }
            } else {

            }
        })
    }

    handleCountryChange(e) {
        this.setState({
            isCountryNotAllowed: e.value !== 'LK',
            selectedCountry: e.value,
            countryKey: this.state.countryKey + 1,
            countryplaceholder: e.label
        }, () => this.MobileNumberValidate())
    };

    onChangeSetState(e) {
        let valid = true;
        if (e.target.name == "FirstName") {
            if (!(/^[A-Za-z]+$/.test(e.target.value) || e.target.value == '')) {
                valid = false;
            }
        } else if (e.target.name == "LastName") {
            if (!(/^[A-Za-z ]+$/.test(e.target.value) || e.target.value == '')) {
                valid = false;
            }
        }
        else if (e.target.name == "MobileNumber") {
            if (!(/^[0-9]+$/.test(e.target.value) || e.target.value == '')) {
                valid = false;
            }
        } else if (e.target.name == "OTPNumber") {
            if (!(/^[0-9]+$/.test(e.target.value) || e.target.value == '')) {
                valid = false;
            }
        }
        if (valid) {
            this.setState({ [e.target.name]: e.target.value }, () => {
                if (this.state.isCheckingOTPValidity) { this.OTPValidate(); }
                { this.MobileNumberValidate(); }
                if (this.state.isCheckingRegistration) { this.ValidateMemberDetails(); }
            })
        }
    }

    MobileNumberValidate() {
        let isFailed = false;
        if (this.state.MobileNumber === '') {
            this.setState({ isCheckingMobileNumberValidity: true, isMobileNumberNotValid: true });
            isFailed = true;
        }
        else if (!this.state.isCountryNotAllowed) {
            let phoneRegex = RegExp('^0[7][0-9]{8}$');
            if (!phoneRegex.test(this.state.MobileNumber)) {
                this.setState({ isCheckingMobileNumberValidity: true, isMobileNumberNotValid: true });
                isFailed = true;
            } else { this.setState({ isMobileNumberNotValid: false }); }
        }
        else {
            this.setState({ isMobileNumberNotValid: false });
        }
        return isFailed;
    };

    VerifyPhoneNumber() {
        if (!this.MobileNumberValidate()) {
            this.props.showLoadingScreen();
            get(`/Registration/SendRegistrationOTP?mobileNumber=${this.state.MobileNumber}&reference`).then(response => {
                if (response.data.statusCode === 200) {
                    this.setState({
                        isRequestSent: true,
                        OTPKey: response.data.result.otpKey,
                        isDisabledResend: true,
                        timerKey: this.state.timerKey + 1,
                        isNextActive: false
                    });
                } else {
                    let errorType = response.data.errorList[0].errorType;
                    let messageBox = {
                        show: true,
                        title: errorTypesEnum.error === errorType ? "Oops!" : errorTypesEnum.warning === errorType ? "Warning" : "Information",
                        className: errorTypesEnum.error === errorType ? "error" : errorTypesEnum.warning === errorType ? "warning" : "info",
                        content: response.data.errorList[0].statusMessage,
                        isConfirmation: false,
                        isNextActive: true,
                        callBackFunction: null
                    }
                    
                    this.props.showMessageBox(messageBox);
                }
                this.props.hideLoadingScreen();
            })
        }
    };

    OTPValidate() {
        let isFailed = false;
        if (this.state.OTPNumber === '') {
            this.setState({ isCheckingOTPValidity: true, isOTPNotValid: true })
            isFailed = true;
        }
        else {
            this.setState({ isOTPNotValid: false });
        }
        return isFailed;
    };

    VerifyOTPNumber() {
        if (!this.OTPValidate()) {
            this.props.showLoadingScreen();
            get(`/Registration/ValidateRegistrationOTP?reference=${this.state.OTPKey}&otp=${this.state.OTPNumber}`).then(response => {
                if (response.data.statusCode === 200) {
                    this.setState({
                        isOTPValidate: true,
                        FirstName: response.data.result.firstName != null ? response.data.result.firstName : '',
                        LastName: response.data.result.lastName != null ? response.data.result.lastName : '',
                        AddressLine1: response.data.result.addressLine1 != null ? response.data.result.addressLine1 : '',
                        AddressLine2: response.data.result.addressLine2 != null && response.data.result.addressLine2 != '' ?
                            response.data.result.addressLine3 != null && response.data.result.addressLine3 != '' ?
                                `${response.data.result.addressLine2}, ${response.data.result.addressLine3}` : response.data.result.addressLine3 : '',
                        Email: response.data.result.email != null ? response.data.result.email : '',
                        City: response.data.result.city != null ? response.data.result.city : '',
                        isNexusMember: (response.data.result.nexusCustID === '' || response.data.result.nexusCustID === null) ? false : true ,
                        isNextActive: true
                    });
                } else {
                    let errorType = response.data.errorList[0].errorType;
                    let messageBox = {
                        show: true,
                        title: errorTypesEnum.error === errorType ? "Oops!" : errorTypesEnum.warning === errorType ? "Warning" : "Information",
                        className: errorTypesEnum.error === errorType ? "error" : errorTypesEnum.warning === errorType ? "warning" : "info",
                        content: response.data.errorList[0].statusMessage,
                        isConfirmation: false,
                        callBackFunction: null
                    }
                    this.props.showMessageBox(messageBox);
                }
                this.props.hideLoadingScreen();
            })
        }
    };

    ValidateMemberDetails() {
        let isFailed = false;

        if (this.state.FirstName === '') { this.setState({ isCheckingRegistration: true, isFirstNameNotValid: true }); isFailed = true; }
        else { this.setState({ isFirstNameNotValid: false }); }

        if (this.state.LastName === '') { this.setState({ isCheckingRegistration: true, isLastNameNotValid: true }); isFailed = true; }
        else { this.setState({ isLastNameNotValid: false }); }

        if (this.state.AddressLine1 === '') { this.setState({ isCheckingRegistration: true, isAddressLine1NotValid: true }); isFailed = true; }
        else { this.setState({ isAddressLine1NotValid: false }); }

        if (this.state.AddressLine2 === '') { this.setState({ isCheckingRegistration: true, isAddressLine2NotValid: true }); isFailed = true; }
        else { this.setState({ isAddressLine2NotValid: false }); }

        if (this.state.Email === '') { this.setState({ isCheckingRegistration: true, isEmailNotValid: true, isWrongEmailAddress: false }); isFailed = true; }
        else if (!(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/).test(this.state.Email)) { this.setState({ isCheckingRegistration: true, isEmailNotValid: false, isWrongEmailAddress: true }); isFailed = true; }
        else { this.setState({ isEmailNotValid: false, isWrongEmailAddress: false }); }

        if (this.state.City === '') { this.setState({ isCheckingRegistration: true, isCityNotValid: true }); isFailed = true; }
        else { this.setState({ isCityNotValid: false }); }

        if (this.state.Title === 'Title') { this.setState({ isCheckingRegistration: true, isTitleNotValid: true }); isFailed = true; }
        else { this.setState({ isTitleNotValid: false }); }

        if (this.state.ConfirmPassword === '') { this.setState({ isCheckingRegistration: true, isConfirmPasswordNotValid: true }); isFailed = true; }
        else { this.setState({ isConfirmPasswordNotValid: false }); }

        if (this.state.Password !== '' && this.state.ConfirmPassword !== '' && this.state.Password !== this.state.ConfirmPassword) { this.setState({ isCheckingRegistration: true, isPasswordNotMatchedNotValid: true }); isFailed = true; }
        else { this.setState({ isPasswordNotMatchedNotValid: false }); }

        var response = checkPasswordComplexity(this.state.Password);
        if (!response.result) {
            this.setState({ isCheckingRegistration: true, isPasswordNotValid: true, passwordError: response.error })
            isFailed = true;
        } else {
            this.setState({ isPasswordNotValid: false, passwordError: "" });
        }

        return isFailed;
    }

    CompleteRegistration() {
        if (this.state.activeView === 2 && !this.state.isAgreedForCondition) {
            let messageBox = {
                show: true,
                title: "Terms & Conditions",
                className: "warning",
                content: "Please agreed to our terms & conditions",
                isConfirmation: false,
                callBackFunction: null
            }
            this.props.showMessageBox(messageBox);
        }
        else {
            if (!this.ValidateMemberDetails()) {
                this.props.showLoadingScreen();
                let formData = {
                    MobileNumber: this.state.MobileNumber,
                    Title: this.state.Title,
                    FirstName: this.state.FirstName,
                    LastName: this.state.LastName,
                    AddressLine1: this.state.AddressLine1,
                    AddressLine2: this.state.AddressLine2,
                    City: this.state.City,
                    PreferedOutlet: '',
                    MobileCountryCode: this.state.mobileCountryCode,
                    Otp:this.state.OTPNumber,

                    Email: this.state.Email,
                    Password: this.state.Password,
                }

                post(`/Registration/RegisterCustomer`, formData).then(response => {
                    if (response.data.statusCode === 200) {
                        // GtagEvent({ action: 'register', category: 'form', label: 'New user register' });
                        this.setState({ isOTPValidate: true, activeView: 3 });
                    } else {
                        let errorType = response.data.errorList[0].errorType;
                        let messageBox = {
                            show: true,
                            title: errorTypesEnum.error === errorType ? "Oops!" : errorTypesEnum.warning === errorType ? "Warning" : "Information",
                            className: errorTypesEnum.error === errorType ? "error" : errorTypesEnum.warning === errorType ? "warning" : "info",
                            content: response.data.errorList[0].statusMessage,
                            isConfirmation: false,
                            callBackFunction: null
                        }
                        this.props.showMessageBox(messageBox);
                    }
                    this.props.hideLoadingScreen();
                })
            }
            else {
                if (this.props.responsive.isMobileLargeScreen || this.props.responsive.isMobileSmallScreen) {
                    let messageBox = {
                        show: true,
                        title: "Required Fields Empty",
                        className: "warning",
                        content: "Please fill all required fields",
                        isConfirmation: false,
                        callBackFunction: null
                    }
                    this.props.showMessageBox(messageBox);
                }
            }
        }
    };

    handleHideMessage() {
        this.setState({
            messageBox: {
                show: false,
                title: "",
                className: "",
                content: "",
                isConfirmation: false,
                callBackFunction: null
            }
        })
    };

    passwordVisibility(param) {
        if (param === "PW") {
            var passwordField = document.getElementById("registerPassword");
            var pwVisibleIcon = document.getElementById("register_pw_visible_icon");
            if (passwordField.type === "password") {
                passwordField.type = "text";
                pwVisibleIcon.classList.replace("fa-eye-slash", "fa-eye");
            } else {
                passwordField.type = "password";
                pwVisibleIcon.classList.replace("fa-eye", "fa-eye-slash");
            }
        } else {
            var confirmPWField = document.getElementById("registerConfirmPassword");
            var pwVisibleIcon = document.getElementById("register_cpw_visible_icon");
            if (confirmPWField.type === "password") {
                confirmPWField.type = "text";
                pwVisibleIcon.classList.replace("fa-eye-slash", "fa-eye");
            } else {
                confirmPWField.type = "password";
                pwVisibleIcon.classList.replace("fa-eye", "fa-eye-slash");
            }
        }
    };

    handleBackBtn() {
        this.setState({
            activeView: 1
        })
    }

    render() {
        var isMobile = this.props.responsive.isMobileLargeScreen || this.props.responsive.isMobileSmallScreen;
        var _viewClass = isMobile ? 'col-10 col-10-view' : 'col-5 col-5-view';
        return (
            <div className={`justify-content-center ${this.props.isVisible ? 'd-flex' : 'd-none'}`}>
                <Col className='registration-container' lg="10" md="10" sm="10" xs="12">
                    {
                        this.state.activeView === 3 ? // thank you section
                            <React.Fragment>

                                {

                                    isMobile ?
                                        <div className='thanks-section'>
                                            <div>
                                                <Row className="thanks-logo">
                                                    <Col sm="12" xs="12">
                                                        <a href={`${window.location.origin}/`}>
                                                            <img src={KeellsLogo} className="img-fluid"></img>
                                                        </a> <br /> <br />
                                                    </Col>
                                                </Row>
                                            </div>

                                            <div className="thanks-dev">
                                                <Row>
                                                    <Col sm="12" xs="12">
                                                        <i className='fas fa-check-circle done-icon' />
                                                    </Col>
                                                </Row>
                                                <Row className="thanks-logo">
                                                    <Col sm="12" xs="12">
                                                        <span className='description green'>Congratulations! Your account has been successfully created!</span>
                                                    </Col>
                                                </Row>
                                            </div>

                                            <div className="thanks-dev">
                                                <Row className="thanks-logo">
                                                    <Col sm="12" xs="12">
                                                        <span className='description white'>Thank you for signing up with Keells. Check your email </span>
                                                        <span className='description green'>&nbsp;{`(${this.state.Email})`}&nbsp;</span>
                                                        <span className='description white'>to confirm your account and start shopping.</span>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </div>

                                        :

                                        <div className='thanks-section'>


                                            <a href={`${window.location.origin}/`}>
                                                <img src={KeellsLogo} className="img-fluid"></img>
                                            </a> <br /> <br />

                                            <Row style={{ alignItems: 'center', height: '3rem' }}>
                                                <i className='fas fa-check-circle done-icon' />
                                                <span className='description green pl-2'>Congratulations! Your account has been successfully created!</span>
                                            </Row>
                                            <Row className='justify-content-center'>
                                                <span className='description white'>Thank you for signing up with Keells. Check your email </span>
                                                <span className='description green'>&nbsp;{`(${this.state.Email})`}&nbsp;</span>
                                                <span className='description white'>to confirm your account and start shopping.</span>
                                            </Row>
                                            <Row></Row>
                                        </div>

                                }
                            </React.Fragment>
                            :
                            <React.Fragment>
                                <div className='first-section'>
                                    <Col>
                                        <a href={`${window.location.origin}/`}>
                                            <img src={KeellsLogo} className="img-fluid"></img>
                                        </a> <br /> <br />
                                        <span className='small-title white'>{this.state.activeView === 1 ? "Create" : "Profile"} <b>{this.state.activeView === 1 ? "Account" : "Creation"}</b></span>
                                        <br />  <br />
                                        <span className={`description ${this.state.activeView === 1 ? 'white' : 'green'}`}>
                                            {
                                                this.state.activeView === 1 ?
                                                    <React.Fragment>
                                                        <div className='mb-4' style={{ textAlign: "left" }}>Enter the details to create an account to shop online <br /><br />
                                                            <i className="fas fa-info-circle" />
                                                            &nbsp;If you wish to create your account without verifying the Mobile number, please click "Next" after you enter the Mobile number
                                                        </div>
                                                        <span className='description white'>Have trouble logging in? Call us on <a href="tel:+940112303500" style={{ color: "#64bf47" }}>0112303500</a> (Daily operating hours 8.00a.m to 8.00p.m)
                                                        </span>
                                                    </React.Fragment>
                                                    : <React.Fragment>
                                                        <div className='mb-3 description white' style={{ textAlign: "left" }}>Please verify your details and update the password.
                                                        </div>
                                                        <span className='description white' >Have trouble logging in? Call us on <a href="tel:+940112303500" style={{ color: "#64bf47" }}>0112303500</a> (Daily operating hours 8.00a.m to 8.00p.m)
                                                        </span>
                                                    </React.Fragment>

                                            }
                                        </span>
                                        <div>
                                            {
                                                this.state.activeView === 1 || isMobile ?
                                                    <br />
                                                    :
                                                    <React.Fragment>
                                                        {/* <Button primary className="fas fa-chevron-circle-left back-btn" onClick={this.handleBackBtn.bind(this)}>Back</Button> */}
                                                        <div className='back-btn mt-5' onClick={this.handleBackBtn.bind(this)}>
                                                            <i className='fas fa-chevron-circle-left' /> <span className='ml-2'>Back</span>
                                                        </div>
                                                    </React.Fragment>
                                            }
                                        </div>

                                        {
                                            isMobile || this.state.activeView === 1 ? null
                                                : <React.Fragment>
                                                    <br />  <br />
                                                    <span className='registration-bg-color'>
                                                        Important: Note that only the last 5 carts shopped on www.keellssuper.com in the last 2 years will be reflected on the new site.
                                                    </span>
                                                </React.Fragment>
                                        }
                                    </Col>
                                </div>

                                <div className='second-section pr-3 pl-3'>
                                    <React.Fragment>
                                        {
                                            this.state.activeView === 1 ? // mobile number
                                                <React.Fragment>
                                                    {
                                                        isMobile ?
                                                            <div className='col'>
                                                                <div className="form-group">
                                                                    <label className='white' htmlFor="MobileNumber">Enter your Nexus mobile or Mobile number</label>
                                                                    <div className="input-group">
                                                                        <div className="input-group-prepend set-height-55" style={{ width: "100%" }}>
                                                                            <div className="">
                                                                                <div style={{ width: '13rem' }}>
                                                                                    <Select options={this.state.countryList}
                                                                                        key={this.state.countryKey}
                                                                                        value={this.state.selectedCountry}
                                                                                        placeholder={this.state.countryplaceholder}
                                                                                        onChange={this.handleCountryChange.bind(this)}
                                                                                        theme={theme => ({
                                                                                            ...theme,
                                                                                            borderRadius: '0px 0px 0px 1.375rem',
                                                                                            height: '5px'
                                                                                        })}
                                                                                    />
                                                                                </div>
                                                                                <li className="custom-border" />
                                                                            </div>

                                                                            <input
                                                                                autoComplete='off'
                                                                                name="MobileNumber"
                                                                                placeholder={`${this.state.isCountryNotAllowed ? 'Mobile Number' : '07XXXXXXXX'}`}
                                                                                type="text"
                                                                                style={{ margin: 0 }}
                                                                                onChange={this.onChangeSetState.bind(this)}
                                                                                disabled={this.state.isRequestSent}
                                                                                className="form-control right-margin-15 set-height-55 no-left-radius no-left-border MobileInputHeight"
                                                                                value={this.state.MobileNumber}
                                                                                maxLength={!this.state.isCountryNotAllowed ? 10 : 50} />
                                                                        </div>
                                                                        <Button secondary floatRight
                                                                            onClick={this.VerifyPhoneNumber.bind(this)}
                                                                            disabled={this.state.isDisabledResend || this.state.isCountryNotAllowed}
                                                                            className="new-btn-verify-number"
                                                                        >{`${this.state.isRequestSent ? 'Resend' : 'Verify Number'}`}</Button>
                                                                    </div>
                                                                    <span
                                                                        className={`form-text text-muted ${this.state.isMobileNumberNotValid && this.state.isCheckingMobileNumberValidity ? '' : 'd-none'}`}
                                                                    >Nexus mobile or Mobile number is required</span>
                                                                    <span
                                                                        className={`form-text text-muted ${this.state.isCountryNotAllowed ? '' : 'd-none'}`}
                                                                    >Hello, Sorry we do not have OTP authentication for numbers outside of Sri Lanka, please click next to proceed with the registration.</span>
                                                                </div>
                                                            </div>
                                                            :
                                                            <Row className="row-view">
                                                                <div className='col-10 col-10-view'>
                                                                    <div className="form-group">
                                                                        <label className='white' htmlFor="MobileNumber">Enter your Nexus mobile or Mobile number</label>
                                                                        <div className="input-group">
                                                                            <div className="input-group-prepend set-height-55">
                                                                                {/* <div className="input-group-text flag-drop-custom"> */}
                                                                                <div style={{ width: '12rem' }}>
                                                                                    <Select options={this.state.countryList}
                                                                                        key={this.state.countryKey}
                                                                                        value={this.state.selectedCountry}
                                                                                        placeholder={this.state.countryplaceholder}
                                                                                        onChange={this.handleCountryChange.bind(this)}
                                                                                        theme={theme => ({
                                                                                            ...theme,
                                                                                            borderRadius: '0px 0px 0px 25px',
                                                                                        })}
                                                                                    />
                                                                                </div>
                                                                                {/* </div> */}
                                                                            </div>
                                                                            <input
                                                                                autoComplete="off"
                                                                                name="MobileNumber"
                                                                                placeholder={`${this.state.isCountryNotAllowed ? 'Mobile Number' : '07XXXXXXXX'}`}
                                                                                type="text"
                                                                                disabled={this.state.isRequestSent}
                                                                                onChange={this.onChangeSetState.bind(this)}
                                                                                className="form-control right-margin-15 set-height-55 no-left-radius no-left-border RegistrationDesktopInputHeight"
                                                                                required="required"
                                                                                value={this.state.MobileNumber}
                                                                                maxLength={!this.state.isCountryNotAllowed ? 10 : 50}
                                                                            />
                                                                            <Button primary floatRight
                                                                                appendToTextBox
                                                                                onClick={this.VerifyPhoneNumber.bind(this)}
                                                                                disabled={this.state.isDisabledResend || this.state.isCountryNotAllowed}
                                                                                className="DesktopInputHeight"
                                                                            >{`${this.state.isRequestSent ? 'Resend' : 'Verify Number'}`}</Button>
                                                                        </div>
                                                                        <span className={`form-text text-muted ${this.state.isMobileNumberNotValid && this.state.isCheckingMobileNumberValidity ? '' : 'd-none'}`}
                                                                        >Nexus mobile or Mobile number is required</span>
                                                                        <span className={`form-text text-muted ${this.state.isCountryNotAllowed ? '' : 'd-none'}`}
                                                                        >Hello, Sorry we do not have OTP authentication for numbers outside of Sri Lanka, please click next to proceed with the registration.</span>
                                                                        {/* <span id="UserNameHelpBlock"
                                  className={`form-text text-muted ${this.state.isCountryNotAllowed ? '' : 'd-none'}`}
                                >OTP login is not currently available in selected country</span> */}
                                                                    </div>
                                                                </div>
                                                            </Row>

                                                    }
                                                    {
                                                        isMobile ?
                                                            <div className='col'>
                                                                <div className="form-group">
                                                                    <label className='white' htmlFor="OTPNumber">Verification Code</label>
                                                                    <div className={`input-group to-center`}>
                                                                        {/* <Row style={{ width: '100%' }}>

                                  <Col lg={5}> */}
                                                                        {this.state.isOTPValidate ? <i className='fas fa-check-circle done-icon otp-done-icon' /> : null}
                                                                        <input
                                                                            disabled={!this.state.isRequestSent || !this.state.isDisabledResend || this.state.isOTPValidate}
                                                                            style={{ marginBottom: 10 }}
                                                                            autoComplete='off'
                                                                            maxLength={4}
                                                                            minLength={4}
                                                                            onChange={this.onChangeSetState.bind(this)}
                                                                            name="OTPNumber" placeholder="Verification Code" type="text"
                                                                            value={this.state.OTPNumber}
                                                                            className={`form-control right-margin-15 set-height-55 ${this.state.isOTPValidate ? 'padding-left' : ''}`} />


                                                                        <span id="UserNameHelpBlock3"
                                                                            className={`form-text text-muted col-md-12 col-12 ${this.state.isOTPNotValid && this.state.isCheckingOTPValidity ? '' : 'd-none'}`}
                                                                        >Verification code is required</span>
                                                                        {
                                                                            this.state.isOTPValidate ? null
                                                                                : <Timer
                                                                                    color='white'
                                                                                    key={this.state.timerKey}
                                                                                    minutes={2}
                                                                                    seconds={0}
                                                                                    enableTimer={this.state.isRequestSent}
                                                                                    callForResend={() => { this.setState({ isDisabledResend: false, OTPNumber: '' }) }}
                                                                                />
                                                                        }
                                                                        {/* </Col>
                                  <Col lg={6}> */}
                                                                        <Button secondary
                                                                            onClick={this.VerifyOTPNumber.bind(this)}
                                                                            disabled={!this.state.isRequestSent || !this.state.isDisabledResend || this.state.isOTPValidate}
                                                                        >Submit</Button>
                                                                        {/* </Col>
                                </Row> */}
                                                                        {this.state.isNexusMember ? <span className='description green'> Already a Nexus member? Click Next </span> : null}

                                                                    </div>
                                                                </div>
                                                            </div>
                                                            :
                                                            <Row className="row-view">
                                                                <div className='col-10 col-10-view'>
                                                                    <div className="form-group">
                                                                        <label className='white' htmlFor="OTPNumber">Verification Code</label>
                                                                        <div className={`input-group to-center`}>
                                                                            <Row style={{ width: '100%' }}>
                                                                                {
                                                                                    //    this.state.isOTPValidate ?
                                                                                    //       <div class="input-group-addon"> 
                                                                                    //         <i className='fas fa-check-circle done-icon otp-done-icon' />
                                                                                    //       </div>
                                                                                    //  : null
                                                                                }
                                                                                <Col lg={5}>
                                                                                    {this.state.isOTPValidate ? <i className='fas fa-check-circle done-icon otp-done-icon' /> : null}
                                                                                    <input
                                                                                        disabled={!this.state.isRequestSent || !this.state.isDisabledResend || this.state.isOTPValidate}
                                                                                        style={{ marginBottom: 10 }}
                                                                                        autoComplete='off'
                                                                                        maxLength={4}
                                                                                        minLength={4}
                                                                                        onChange={this.onChangeSetState.bind(this)}
                                                                                        name="OTPNumber" placeholder="Verification Code" type="text"
                                                                                        value={this.state.OTPNumber}
                                                                                        className={`form-control right-margin-15 set-height-55 ${this.state.isOTPValidate ? 'padding-left' : ''}`} />


                                                                                    <span id="UserNameHelpBlock3"
                                                                                        className={`form-text text-muted col-md-12 col-12 ${this.state.isOTPNotValid && this.state.isCheckingOTPValidity ? '' : 'd-none'}`}
                                                                                    >Verification code is required</span>
                                                                                    {
                                                                                        this.state.isOTPValidate ? null
                                                                                            : <Timer
                                                                                                color='white'
                                                                                                key={this.state.timerKey}
                                                                                                minutes={2}
                                                                                                seconds={0}
                                                                                                enableTimer={this.state.isRequestSent}
                                                                                                callForResend={() => { this.setState({ isDisabledResend: false, OTPNumber: '' }) }}
                                                                                            />
                                                                                    }
                                                                                </Col>
                                                                                <Col lg={6}>
                                                                                    <Button secondary
                                                                                        onClick={this.VerifyOTPNumber.bind(this)}
                                                                                        disabled={!this.state.isRequestSent || !this.state.isDisabledResend || this.state.isOTPValidate}
                                                                                    >Submit</Button>
                                                                                </Col>
                                                                            </Row>
                                                                            {this.state.isNexusMember ? <span className='description green'> Already a Nexus member? Click Next </span> : null}

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Row>
                                                    }
                                                </React.Fragment>

                                                // others
                                                : <React.Fragment>

                                                    <Row className="row-view">
                                                        <div className={_viewClass}>
                                                            <Row>
                                                                <Col md='3' sm="12" xs="12" className='mb-2'>
                                                                    <div className="form-group">
                                                                        <label htmlFor="FirstName" className='white'>Title</label>

                                                                        <DropdownButton title={this.state.Title} variant=''>
                                                                            <Dropdown.Item as="button" onClick={() => { this.setState({ Title: 'Mr.' }); }}>Mr.</Dropdown.Item>
                                                                            <Dropdown.Item as="button" onClick={() => { this.setState({ Title: 'Mrs.' }) }}>Mrs.</Dropdown.Item>
                                                                            <Dropdown.Item as="button" onClick={() => { this.setState({ Title: 'Miss.' }) }}>Miss.</Dropdown.Item>
                                                                            <Dropdown.Item as="button" onClick={() => { this.setState({ Title: 'Dr.' }) }}>Dr.</Dropdown.Item>
                                                                            <Dropdown.Item as="button" onClick={() => { this.setState({ Title: 'Rev.' }) }}>Rev.</Dropdown.Item>
                                                                        </DropdownButton>
                                                                    </div>
                                                                </Col>

                                                                <Col>
                                                                    <div className="form-group">
                                                                        <label htmlFor="FirstName" className='white'>First Name</label>
                                                                        <input id="FirstName" name="FirstName" placeholder="First Name" type="text" className="form-control"
                                                                            value={this.state.FirstName}
                                                                            onChange={this.onChangeSetState.bind(this)} />
                                                                    </div>
                                                                </Col>
                                                            </Row>

                                                            {
                                                                this.state.isCheckingRegistration && this.state.isFirstNameNotValid && this.state.isTitleNotValid ?
                                                                    <span className={`form-text text-muted`}> Please select a title and enter the first name.</span>
                                                                    :
                                                                    <React.Fragment>
                                                                        <span className={`form-text text-muted ${this.state.isCheckingRegistration && this.state.isFirstNameNotValid ? '' : 'd-none'}`}> First name is required.</span>
                                                                        <span className={`form-text text-muted ${this.state.isCheckingRegistration && this.state.isTitleNotValid ? '' : 'd-none'}`}> Please select title.</span>
                                                                    </React.Fragment>

                                                            }
                                                        </div>

                                                        <div className={`${_viewClass}`}>
                                                            <div className="form-group">
                                                                <label htmlFor="LastName" className='white'>Last Name</label>
                                                                <input id="LastName" name="LastName" placeholder="Last Name" type="text" className="form-control"
                                                                    value={this.state.LastName}
                                                                    onChange={this.onChangeSetState.bind(this)} />
                                                                <span className={`form-text text-muted ${this.state.isCheckingRegistration && this.state.isLastNameNotValid ? '' : 'd-none'}`}> Last name is required.</span>

                                                            </div>
                                                        </div>
                                                    </Row>

                                                    <Row className="row-view">
                                                        <div className={_viewClass}>
                                                            <div className="form-group">
                                                                <label htmlFor="AddressLine1" className='white'>House No or Lane *</label>
                                                                <input maxLength="100" id="AddressLine1" name="AddressLine1" placeholder="House No or Lane *" type="text" className="form-control"
                                                                    value={this.state.AddressLine1}
                                                                    onChange={this.onChangeSetState.bind(this)} />
                                                            </div>
                                                            <span className={`form-text text-muted ${this.state.isCheckingRegistration && this.state.isAddressLine1NotValid ? '' : 'd-none'}`}> House No or Lane is required.</span>
                                                        </div>
                                                        <div className={_viewClass}>
                                                            <div className="form-group">
                                                                <label htmlFor="AddressLine2" className='white'>Street Name *</label>
                                                                <input maxLength="100" id="AddressLine2" name="AddressLine2" placeholder="Street Name *" type="text" className="form-control"
                                                                    value={this.state.AddressLine2}
                                                                    onChange={this.onChangeSetState.bind(this)} />
                                                                <span className={`form-text text-muted ${this.state.isCheckingRegistration && this.state.isAddressLine2NotValid ? '' : 'd-none'}`}> Street Name * is required.</span>

                                                            </div>
                                                        </div>
                                                    </Row>
                                                    <Row className="row-view">
                                                        <div className={_viewClass}>
                                                            <div className="form-group">
                                                                <label htmlFor="City" className='white'>City *</label>
                                                                <input maxLength="100" id="City" name="City" placeholder="City *" type="text" className="form-control"
                                                                    value={this.state.City}
                                                                    onChange={this.onChangeSetState.bind(this)} />
                                                            </div>
                                                            <span className={`form-text text-muted ${this.state.isCheckingRegistration && this.state.isCityNotValid ? '' : 'd-none'}`}> City is required.</span>
                                                        </div>
                                                    </Row>
                                                    <Col className='hr' />

                                                    <Row className="row-view">
                                                        <div className={_viewClass}>
                                                            <div className="form-group">
                                                                <label htmlFor="Email" className='white'>Email</label>
                                                                <input id="Email" name="Email" placeholder="Email" type="text" className="form-control"
                                                                    value={this.state.Email}
                                                                    onChange={this.onChangeSetState.bind(this)} />
                                                            </div>
                                                            <span className={`form-text text-muted ${this.state.isCheckingRegistration && this.state.isEmailNotValid ? '' : 'd-none'}`}> Email is required.</span>
                                                            <span className={`form-text text-muted ${this.state.isCheckingRegistration && this.state.isWrongEmailAddress ? '' : 'd-none'}`}> Invalid email address.</span>
                                                        </div>
                                                    </Row>
                                                    <Row className="row-view">
                                                        <div className={_viewClass}>
                                                            <div className="form-group">
                                                                <label htmlFor="Password" className='white'>Password</label>
                                                                <div className="input-group" style={{ marginBottom: 0 }}>
                                                                    <input id="registerPassword" name="Password" placeholder="Password" type="password" className="form-control"
                                                                        value={this.state.Password}
                                                                        onChange={this.onChangeSetState.bind(this)} />
                                                                    <i id="register_pw_visible_icon" className="fas fa-eye-slash" onClick={this.passwordVisibility.bind(this, "PW")} />
                                                                </div>
                                                            </div>
                                                            <span className="form-text text-muted">{this.state.passwordError}</span>
                                                        </div>
                                                        <div className={_viewClass}>
                                                            <div className="form-group">
                                                                <label htmlFor="Confirm Password" className='white'>Confirm Password</label>
                                                                <div className="input-group" style={{ marginBottom: 0 }}>
                                                                    <input id="registerConfirmPassword" name="ConfirmPassword" placeholder="Confirm Password" type="password" className="form-control"
                                                                        value={this.state.ConfirmPassword}
                                                                        onChange={this.onChangeSetState.bind(this)} />
                                                                    <i id="register_cpw_visible_icon" className="fas fa-eye-slash" onClick={this.passwordVisibility.bind(this, "CPW")} />
                                                                </div>
                                                            </div>
                                                            <span className={`form-text text-muted ${this.state.isCheckingRegistration && this.state.isConfirmPasswordNotValid ? '' : 'd-none'}`}> Confirm password is required.</span>
                                                            <span className={`form-text text-muted ${this.state.isCheckingRegistration && this.state.isPasswordNotMatchedNotValid ? '' : 'd-none'}`}> Confirm password does not match</span>
                                                        </div>



                                                    </Row>
                                                    <Row className="row-view">
                                                        <Col className="col-10 col-10-view">
                                                            <div className="form-group text-muted forget-pw-guideline">
                                                                <i className="fas fa-info-circle"></i> Your password must contain a minimum of 8 characters with 1 Uppercase, Numeric & Special character.
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    <Row className="row-view">
                                                        <div className='col-10 col-10-view'>
                                                            <div className="form-group">
                                                                <div className="custom-controls-stacked">
                                                                    <div className="custom-control custom-checkbox p-0 pl-1">
                                                                        <Accordion defaultActiveKey='0'>
                                                                            <div>
                                                                                <Accordion.Toggle as={Card.Header} htmlFor="checkbox_0" eventKey="0" className='border-0 pt-0 pb-0' style={{ background: 'transparent' }}>
                                                                                    <input name="checkbox" id="checkbox_0" type="checkbox" className="custom-control-input" value="agreed"
                                                                                        onChange={(e) => {
                                                                                            this.setState({ isAgreedForCondition: e.target.checked, defaultActiveKey: e.target.checked ? '0' : '1' });

                                                                                        }}
                                                                                    />
                                                                                    <label htmlFor="checkbox_0" className="custom-control-label white condition-label">I agree to the Terms and Conditions</label>
                                                                                </Accordion.Toggle>
                                                                                <Accordion.Collapse eventKey={this.state.defaultActiveKey} htmlFor="checkbox_0" >
                                                                                    <Card.Body>
                                                                                        <Row>
                                                                                            <Col className='white conditions'>
                                                                                                <p>I confirm that I will be providing you with my data and hereby expressly consent to the use of my personal data for the purpose of fulfilling the order placed with you. This includes express permission to share data, inclusive of personal data, with your service providers and agents, only as required for the fulfilment of such order. I acknowledge that, in full compliance with applicable regulations, you may share data with your business partners and associates with a view of enriching and enhancing your products and services without compromising my personally identifiable information. I confirm that I have read through your <a href="/mobprivacynotice" target="_blank">Privacy Notice</a> and general <a href="/mobtc" target="_blank">Terms and Conditions</a> and have understood my rights in relation to the personal data which I am providing to you.</p>
                                                                                            </Col>
                                                                                        </Row>

                                                                                    </Card.Body>
                                                                                </Accordion.Collapse>
                                                                            </div>
                                                                        </Accordion>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Row>
                                                </React.Fragment>
                                        }
                                        <Row className="row-view">
                                            <div className='col-10 col-10-view'>
                                                <div className="form-group">
                                                    <Button
                                                        className='mt-2'
                                                        // disabled={(this.state.activeView === 1 && this.state.isMobileNumberNotValid) || (this.state.activeView === 2 && !this.state.isAgreedForCondition)}
                                                        disabled={(this.state.activeView === 1 && this.state.isMobileNumberNotValid) || (this.state.activeView === 1 && !this.state.isNextActive) || (!this.state.isOTPValidate && !this.state.isCountryNotAllowed) || (this.state.isOTPValidate && this.state.isCountryNotAllowed)}
                                                        onClick={() => {
                                                            if (this.state.activeView === 2) this.CompleteRegistration();
                                                            else this.setState({ activeView: 2 })
                                                        }}
                                                        primary>{this.state.activeView === 1 ? "Next" : "Submit"}</Button>
                                                </div>
                                            </div>
                                        </Row>

                                    </React.Fragment>
                                </div>
                                {/* <MessageBox key={this.state.messageBox.show} messageBox={this.state.messageBox}
                  handleHideMessage={() => this.handleHideMessage()} callBackFunction={this.state.messageBox.callBackFunction} /> */}
                            </React.Fragment>
                    }

                </Col>
            </div>
        )
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(RegistrationView);